import styled from "styled-components"

export const RattingListWrapper = styled.div`
    .ratting_list{
        list-style: none;
    }
`
